// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocStatus } from './docStatus';
import {
    DocStatusFromJSON,
    DocStatusFromJSONTyped,
    DocStatusToJSON,
    DocStatusToJSONTyped,
} from './docStatus';
import type { ProjectStatus } from './projectStatus';
import {
    ProjectStatusFromJSON,
    ProjectStatusFromJSONTyped,
    ProjectStatusToJSON,
    ProjectStatusToJSONTyped,
} from './projectStatus';
import type { Variable } from './variable';
import {
    VariableFromJSON,
    VariableFromJSONTyped,
    VariableToJSON,
    VariableToJSONTyped,
} from './variable';
import type { ProjectMetadata } from './projectMetadata';
import {
    ProjectMetadataFromJSON,
    ProjectMetadataFromJSONTyped,
    ProjectMetadataToJSON,
    ProjectMetadataToJSONTyped,
} from './projectMetadata';

/**
 * 
 * @export
 * @interface Project
 */
export interface Project {
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    selected?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Project
     */
    selectedTime?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    locked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Project
     */
    hasUpdates?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    completions?: number;
    /**
     * 
     * @type {DocStatus}
     * @memberof Project
     */
    docStatus?: DocStatus;
    /**
     * 
     * @type {Array<string>}
     * @memberof Project
     */
    completedBy?: Array<string>;
    /**
     * 
     * @type {ProjectStatus}
     * @memberof Project
     */
    status?: ProjectStatus;
    /**
     * 
     * @type {number}
     * @memberof Project
     */
    progress?: number;
    /**
     * 
     * @type {ProjectMetadata}
     * @memberof Project
     */
    metadata?: ProjectMetadata;
    /**
     * 
     * @type {Array<Variable>}
     * @memberof Project
     */
    variables?: Array<Variable>;
}



/**
 * Check if a given object implements the Project interface.
 */
export function instanceOfProject(value: object): value is Project {
    return true;
}

export function ProjectFromJSON(json: any): Project {
    return ProjectFromJSONTyped(json, false);
}

export function ProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): Project {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'selected': json['selected'] == null ? undefined : json['selected'],
        'selectedTime': json['selectedTime'] == null ? undefined : json['selectedTime'],
        'locked': json['locked'] == null ? undefined : json['locked'],
        'hasUpdates': json['hasUpdates'] == null ? undefined : json['hasUpdates'],
        'completions': json['completions'] == null ? undefined : json['completions'],
        'docStatus': json['docStatus'] == null ? undefined : DocStatusFromJSON(json['docStatus']),
        'completedBy': json['completedBy'] == null ? undefined : json['completedBy'],
        'status': json['status'] == null ? undefined : ProjectStatusFromJSON(json['status']),
        'progress': json['progress'] == null ? undefined : json['progress'],
        'metadata': json['metadata'] == null ? undefined : ProjectMetadataFromJSON(json['metadata']),
        'variables': json['variables'] == null ? undefined : ((json['variables'] as Array<any>).map(VariableFromJSON)),
    };
}

export function ProjectToJSON(json: any): Project {
    return ProjectToJSONTyped(json, false);
}

export function ProjectToJSONTyped(value?: Project | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'selected': value['selected'],
        'selectedTime': value['selectedTime'],
        'locked': value['locked'],
        'hasUpdates': value['hasUpdates'],
        'completions': value['completions'],
        'docStatus': DocStatusToJSON(value['docStatus']),
        'completedBy': value['completedBy'],
        'status': ProjectStatusToJSON(value['status']),
        'progress': value['progress'],
        'metadata': ProjectMetadataToJSON(value['metadata']),
        'variables': value['variables'] == null ? undefined : ((value['variables'] as Array<any>).map(VariableToJSON)),
    };
}

